<template>
  <div>
    <v-tabs v-model="tab" grow color="primary">
      <v-tab value="album">アルバム</v-tab>
      <v-tab value="sales">売上情報</v-tab>
      <v-tab value="purchase-history">購入履歴</v-tab>
    </v-tabs>
    <v-divider />

    <v-window v-model="tab" class="mt-6">
      <v-window-item value="album">
        <memoru-album />
      </v-window-item>
      <v-window-item value="sales">
        <memoru-sales />
      </v-window-item>
      <v-window-item value="purchase-history">
        <memoru-purchase-history />
      </v-window-item>
    </v-window>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MemoruAlbum from "@/views/memoru/MemoruAlbum.vue";
import MemoruPurchaseHistory from "@/views/memoru/MemoruPurchaseHistory.vue";
import MemoruSales from "@/views/memoru/MemoruSales.vue";

export default defineComponent({
  name: "MemoruTop",

  components: {
    MemoruAlbum,
    MemoruPurchaseHistory,
    MemoruSales,
  },

  data() {
    return {
      tab: "album", 
    };
  },
});
</script>